import AreYouSureButtons from "Components/molecule/are-you-sure-buttons"
import Modal from "Components/molecule/modal"
import { useState } from "react"

interface AreYouSureModalProps {
    isOpen: boolean
    onModalClose: () => any
    modalTitle?: string
    subTitle?: string
    handleAreYouSureAccept?: () => Promise<any>
    handleAreYouSureDecline?: () => Promise<any>
    areYouSureacceptText?: string
    areYouSuredeclineText?: string
    handleSyncData?: () => any
}


const AreYouSureModal = ({
    onModalClose,
    modalTitle,
    subTitle,
    handleAreYouSureAccept,
    handleAreYouSureDecline,
    areYouSureacceptText,
    areYouSuredeclineText,
    isOpen,
}: AreYouSureModalProps) => {
    const [processing, setProcessiong] = useState<boolean>(false);
    const handleAccept = async () => {
        if (!handleAreYouSureAccept)
            return;

        setProcessiong(true)
        await handleAreYouSureAccept();
        setProcessiong(false)
    }
    return <Modal
        isOpen={isOpen}
        onClose={onModalClose}
        title={modalTitle ?? ''}
        subtitle={subTitle}
    >
        {
            handleAreYouSureAccept &&
            handleAreYouSureDecline &&
            areYouSureacceptText && areYouSuredeclineText &&
            <AreYouSureButtons
                disable={processing}
                handleAccept={handleAccept}
                handleDecline={handleAreYouSureDecline}
                acceptText={areYouSureacceptText}
                declineText={areYouSuredeclineText}
            />

        }
    </Modal>
}


export default AreYouSureModal